const boxShadow = {
  s: '0px 0px 16px rgba(0, 0, 0, 0.05), 0px 0px 8px rgba(0, 0, 0, 0.1)',
  base: '0px 15px 10px rgba(0, 0, 0, 0.02), 0px 15px 20px rgba(0, 0, 0, 0.05), 0px 25px 56px rgba(0, 0, 0, 0.1)',
  card: 'inset 0px 2px 16px rgba(0, 0, 0, 0.05), 0px 2px 8px rgba(0, 0, 0, 0.1)',
};

export type SystemBoxShadowMap = typeof boxShadow;
export type SystemBoxShadow = keyof SystemBoxShadowMap;
export default boxShadow;
